import REDUX_CONSTANTS from '../../../../shared/constants/redux.constants';
import { getHotSpotCategoriesConfig } from '../../../../shared/api/HotspotApi';

const GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_CALLED = 'GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_CALLED';
const GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED = 'GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED';
const GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_FAILED = 'GET_CATEGORIES_FOR_CUSTOMERS_ID_REQUEST_FAILED';
const CREATE_CATEGORY = 'CREATE_CATEGORY';


export const getHotSpotsCategories = ({
    customerType, customerId,
}) => ({
    type: GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_CALLED,
    actionTypes: {
        success: GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED,
        fail: GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_FAILED,
    },
    config: getHotSpotCategoriesConfig({
        customerType, customerId,
    }),
});

export const createCategory = ({
    newCategory,
}) => ({
    type: CREATE_CATEGORY,
    newCategory,
});

const initialState = {
    loadState: 'loading',
    data: [],
    error: null,
};

export const hotSpotCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_CALLED:
        return {
            ...state,
            loadState: REDUX_CONSTANTS.LOAD_STATE.LOADING,
            data: [],
            error: null,

        };
    case GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED:
        return {
            ...state,
            loadState: REDUX_CONSTANTS.LOAD_STATE.SUCCESS,
            data: action.payload.data,
            error: null,

        };
    case GET_CATEGORIES_FOR_CUSTOMER_ID_REQUEST_FAILED:
        return {
            ...state,
            loadState: REDUX_CONSTANTS.LOAD_STATE.FAIL,
            data: [],
            error: action.payload,

        };
    case CREATE_CATEGORY:
        return {
            ...state,
            data: [...state.data,
                { id: action.newCategory, value: action.newCategory, name: action.newCategory },
            ],
        };
    default:
        return state;
    }
};
